import React from 'react';
import css from './BatchSentItemsTable.scss';
import BatchSentItemsRow from './BatchSentItemsRow';
import SortableTable from '../SF/table/SortableTable';
import { withLoader } from '../common/withLoader';
import PropTypes from 'prop-types';

class BatchSentItemsTable extends React.Component {
  
  render() {
    return (
      <SortableTable className={css['batch-sent-items-table']} 
                     columnToSort="requestDate" 
                     fixed 
                     headers={[
                       {
                         content: "Action"
                       }, {
                         content: "Date Sent"
                       }, {
                         content: "No. of Recipients",
                         textAlign: "right"
                       }, {
                         content: "Completion Status",
                         textAlign: "right"
                       }
                     ]} 
                     itemName="Items" 
                     items={this.props.items} 
                     renderItem={(item, index) => <BatchSentItemsRow {...item} key={index} /> }
                     shouldPaginate={false} 
                     totalItems={this.props.items.length} 
                     unstackable />
    );
  }
  
}

BatchSentItemsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    batchedActionId: PropTypes.number.isRequired,
    actionType: PropTypes.string.isRequired,
    completionPercentage: PropTypes.number,
    requestDate: PropTypes.string.isRequired,
    batchedActionItemsCount: PropTypes.number.isRequired,
    batchedActionStatus: PropTypes.string.isRequired
  }))
};

export default withLoader(BatchSentItemsTable);
